export default __webpack_public_path__ + "static/media/promo-banner-staking.a971f6be.svg";